//Disease Value
export * from './_entity/disease-value/index.js';
export * from './_entity/disease-value/index.js';
//Disease View
export * from './_entity/disease-view/index.js';
export * from './_entity/disease-view/index.js';
//Disease Profile
export * from './_entity/disease-profile/index.js';
export * from './_entity/disease-profile/index.js';
//Color Group
export * from './_entity/color-group/index.js';
export * from './_entity/color-group/index.js';
//Mutli Var
export * from './_entity/multi-var/index.js';
export * from './_entity/multi-var/index.js';
//# sourceMappingURL=_entity.js.map